export enum ServiceStepEnum {
  additionalFactors = "/additional-factors",
  availability = "/availability",
  calendarWindows = "/calendar-windows",
  confirmation = "/confirmation",
  contactInformation = "/your-contact-information",
  destinationDwellingInformation = "/destination-dwelling-information",
  destinationLocation = "/your-destination-location",
  dwellingInformation = "/dwelling-information",
  kindOfItems = "/kind-of-items",
  numberBedrooms = "/number-bedrooms",
  pickUpLocation = "/your-pick-up-location",
  truckLoads = "/truck-loads",
  provideMoreDetails = "/provide-more-details",
  targetDate = "/target-date",
}

export type StepKey = keyof typeof ServiceStepEnum;
